import client from './client';

export const getProviderDailyHoursApi = providerId => client().get('/provider-daily-hours', { params: { providerId } });

export const createProviderDailyHoursApi = data => client().post('/provider-daily-hours', data);

export const removeProviderDailyHourApi = id => client().delete(`/provider-daily-hours/${id}`);

export const updateProviderDailyHourApi = data => client().put(`/provider-daily-hours/${data.id}`, data);
